module.exports = __webpack_public_path__ + "img/create-account.0de83603.svg";